import React from "react";
import { resolveValue, Toaster } from "react-hot-toast";
import { Transition } from "@headlessui/react";
import { AlertInCircleIcon, CheckInCircleIcon } from "./fancyIcons";
import classNames from "classnames";
import useWindowSize from "../../hooks/useWindowSize";

const toasterClasses = classNames(
  "tw-mb-4",
  "tw-flex",
  "tw-transform",
  "tw-items-center",
  "tw-gap-2",
  "tw-rounded-lg",
  "tw-bg-neutral-950",
  "tw-fill-white",
  "tw-stroke-white",
  "tw-px-4",
  "tw-py-2",
  "tw-text-base/6",
  "tw-text-white",
  "tw-opacity-90",
  "tw-shadow-xl",
  "tw-transition-all",
  "tw-duration-150",
);

const enterFromClasses = classNames(
  "tw-opacity-0",
  "tw-scale-50",
  "tw-translate-y-1/2",
);

const enterToClasses = classNames(
  "tw-opacity-90",
  "tw-scale-100",
  "tw-translate-y-0",
);

const leaveFromClasses = classNames(
  "tw-opacity-90",
  "tw-scale-100",
  "tw-translate-y-0",
);

const leaveToClasses = classNames(
  "tw-opacity-0",
  "tw-scale-75",
  "tw-translate-y-1/2",
);

const ToasterOven = () => {
  const { isMobile } = useWindowSize();

  return (
    <Toaster
      position={isMobile ? "top-center" : "bottom-center"}
      toastOptions={{ duration: 2000 }}
      gutter={4}
    >
      {(t) => {
        return (
          <Transition
            appear
            show={t.visible}
            className={toasterClasses}
            enterFrom={enterFromClasses}
            enterTo={enterToClasses}
            leaveFrom={leaveFromClasses}
            leaveTo={leaveToClasses}
          >
            {t.icon ||
              (t.type === "error" ? (
                <AlertInCircleIcon width={24} height={24} />
              ) : (
                <CheckInCircleIcon width={24} height={24} />
              ))}
            <div>{resolveValue(t.message, t)}</div>
          </Transition>
        );
      }}
    </Toaster>
  );
};

export default ToasterOven;
